import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
import { DELIVERED, short } from '@/lib/intentDemo';

export function IntentComparison({ checked, result }) {
  if (!checked) {
    return <div className="rounded-xl border border-white/10 p-4 text-sm text-gray-500" data-testid="intent-compare-empty">The store's signed Fulfillment Statement for {DELIVERED.orderRef} will be compared with the person's signed intent.</div>;
  }
  const ok = result.termsMatch && result.rows.every((r) => r.ok);
  return (
    <div className={`rounded-xl border p-4 ${ok ? 'border-emerald-500/40' : 'border-red-500/40'}`} data-testid="intent-compare-result">
      <div className="text-xs uppercase tracking-widest text-gray-500 mb-2">Comparison: intent vs. {DELIVERED.orderRef}</div>
      <div className="grid grid-cols-[auto_minmax(0,1fr)_minmax(0,1fr)_auto] gap-x-2 sm:gap-x-3 gap-y-1.5 text-xs sm:text-sm items-center">
        <span className="text-xs text-gray-500">Field</span><span className="text-xs text-gray-500">Asked for</span><span className="text-xs text-gray-500">Delivered</span><span />
        {result.rows.map((r) => (
          <React.Fragment key={r.field}>
            <span className="text-gray-400">{r.field}</span>
            <span className="text-gray-200 break-words">{r.asked}</span>
            <span className={`break-words ${r.ok ? "text-gray-200" : "text-red-200 font-semibold"}`} data-testid={`intent-row-${r.field.toLowerCase()}`}>{r.got}</span>
            {r.ok ? <CheckCircle2 className="w-4 h-4 text-emerald-400" /> : <XCircle className="w-4 h-4 text-red-400" />}
          </React.Fragment>
        ))}
      </div>
      <div className="font-mono text-[11px] text-gray-500 mt-3 break-all">delivered termsHash {short(result.deliveredHash)} {result.termsMatch ? 'matches' : 'does not match'} the signed intent</div>
      <p className={`text-sm mt-3 ${ok ? 'text-emerald-100/90' : 'text-red-100/90'}`} data-testid="intent-verdict">
        {ok
          ? 'Match. The person signed size 9 as a separate change, so the record shows they asked for what arrived.'
          : 'Terms mismatch. The person signed for size 10. Size 9 shipped, and no signed version ever approved it.'}
      </p>
      <p className="text-xs text-gray-500 mt-2" data-testid="intent-note">The record shows what was asked for and what was delivered. The store decides under its own policy. Kojiru makes no decision.</p>
    </div>
  );
}
